<script lang="ts" context="module">import { getContext, setContext } from 'svelte';
import { writable } from 'svelte/store';
const storeContextSymbol = Symbol('searchOptions');
export function initSearchOptions(options) {
    const store = writable(options);
    setContext(storeContextSymbol, store);
    return store;
}
export function getSearchOptionsStore() {
    return getContext(storeContextSymbol);
}
</script>

<script lang="ts">export let options;
const store = initSearchOptions(options);
// Update search options store whenever options prop change.
$: store.set(options);
</script>

<slot />
